import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { faAngleDown, faAngleRight, faChartLine, faCircleInfo, faFile, faMicrochip, faUpload, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import DataSource from 'devextreme/data/data_source';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MachineInfoMainService } from '../../shared/services/machine-info.service';
import { MachineOwnerService } from '../../shared/services/owner.service';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MachineInfo, MachineOwner } from 'src/api/generated';
import { MessagesService } from 'src/app/shared/services/messages.service';
import { DxDataGridComponent } from 'devextreme-angular';
import {Location} from '@angular/common';
import {TranslateWithFallbackPipe} from 'acl-cloud-lib';

@Component({
  templateUrl: './machine-info.component.html',
  styleUrl: './machine-info.component.scss',
})
export class MachineInfoComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  faAngleDown = faAngleDown;
  faAngleRight = faAngleRight;
  faCircleInfo = faCircleInfo;
  faChartLine = faChartLine;
  faMicrochip = faMicrochip;
  faFile = faFile;
  faUpload = faUpload;
  faArrowBack = faArrowLeft
  modalRef?: BsModalRef;
  message: string = "";
  progress: number = 0;
  loadIndicatorVisible: boolean = false;
  @ViewChild('templateUpload') templateRef: TemplateRef<any> | undefined;
  public ownersDs: DataSource<MachineOwner, string>;
  //declares a FormGroup
  public frmData: FormGroup;
  isSmallScreen: boolean = false;
  isShowed: boolean[] = [];
  public currentRow: MachineInfo | undefined;
  public filterValue: any;
  public redirectedFromWidget: boolean = false;

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid?: DxDataGridComponent;

  constructor(
    private _miSvc: MachineInfoMainService,
    private _oSvc: MachineOwnerService,
    private _modalService: BsModalService,
    private _router: Router,
    fb: FormBuilder,
    private _messSvc: MessagesService,
    private breakpointObserver: BreakpointObserver,
    private readonly _route: ActivatedRoute,
    private readonly _location: Location,
    private readonly _cd: ChangeDetectorRef,
    private _translatePipe: TranslateWithFallbackPipe
  ) {
    this.ownersDs = _oSvc.ListDataSource;
    //We define the FormGroup
    this.frmData = fb.group({
      OwnerName: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }

  ngAfterViewInit(): void {
    if (this._route.snapshot.queryParamMap.has('state') && this.dataGrid) {
      this.filterValue = ['CurrentStatus', '=', this._route.snapshot.queryParamMap.get('state')];
      this.dataGrid.filterSyncEnabled = true;
      this.redirectedFromWidget = true;
      this.dataGrid.filterValue = ['CurrentStatus', '=', this._route.snapshot.queryParamMap.get('state')];
    }
  }

  ngAfterViewChecked(): void {
    this._cd.detectChanges();
  }

  ngOnDestroy(): void {
    this._cd.detach();
  }

  onRowClick(e: any) {
    if (e.data) {
      this._router.navigate(['/machine', e.data.Id]);
    }
  }

  public get MiSvc(): MachineInfoMainService {
    return this._miSvc;
  }

  public get OSvc(): MachineOwnerService {
    return this._oSvc;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template);
  }

  decline(): void {
    this.modalRef?.hide();
  }

  uploadFile = (files: FileList) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];

    this.loadIndicatorVisible = true;
    this.MiSvc.restore(fileToUpload, this.frmData.get('OwnerName')!.value)
      .subscribe({
        next: (event) => {
          if (event) {
            this.loadIndicatorVisible = false;
            this.modalRef?.hide();
            this.openModal(this.templateRef!);

            if (event.type === HttpEventType.UploadProgress)
              this.progress = Math.round(100 * event.loaded / event.total!);
            else if (event.type === HttpEventType.Response) {
              this.modalRef?.hide();
              this.message = this._translatePipe.transform('upload-success');
              window.location.reload();
            }
          }
          else{
            this.message = this._translatePipe.transform('upload-success');
            this.modalRef?.hide();
            this._messSvc.ShowSuccess(this.message);
            this.loadIndicatorVisible = false;
            this.MiSvc.dataSource.reload();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.loadIndicatorVisible = false;
          this._messSvc.ShowError(JSON.stringify(err));
          console.error(err);
        }
      }
    );
  }

  getOwnerName(ownerId: string): string {
    const owner = this.OSvc.AllOwners.find(o => o.Id === ownerId);
    return owner ? owner.Name ?? "" : '-';
  }

  show(rowIndex: number): void {
    this.isShowed[rowIndex] = !this.isShowed[rowIndex];
  }

  changeOwnerBackup(ownerName: any) {
    this.frmData.get('OwnerName')?.setValue(ownerName.value);
  }

  back(): void {
    this._location.back();
  }
}
